import React from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import { Form, Input, Select, message, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { submitPending, pendingReasonEnum } from '@/services/customerServices';
import styles from './index.module.less'
import {trimStr} from "@/utils/data.ts";
import {cluePending} from "@/services/callCenter";

const TextArea = Input.TextArea;

export default function SubmitPendingModal ({
  editId = '',
  open = false,
  buttonKey = '',
  onClose = () => {},
  reload = () => {},
})  {
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDictionaryData();
  }, []);

  const fetchDictionaryData = async () => {
    try {
      const resList: any = await Promise.allSettled([
        pendingReasonEnum(),
      ]);
      const map = {
        reason: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
        setLoading(true);
        cluePending({ clueId: editId, buttonKey, ...values })
            .then(res => {
              message.success(res.message || '提交待定成功');
              onClose();
              reload();
            }).finally(() => setLoading(false))
    })
  }

  return (
    <div className={styles.submitPendingModal}>
      <SDrawerOrModal
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={500}
        title="提交待定"
      >
        <Form
          form={form}
          name="basicInfo"
          layout="vertical"
        >
          <Form.Item
            name="reasonCode"
            label="待定原因"
            rules={[
              {
                required: true,
                message: '请选择待定原因',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择待定原因'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['reason']}
            onChange={(e, op) => form.setFieldValue('reasonName', op.description)}/>
          </Form.Item>
          <Form.Item name={'reasonName'} hidden>
            <Input/>
          </Form.Item>
          <Form.Item
            name="describe"
            label="说明"
            rules={[
              {
                required: true,
                message: '请填写说明',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <TextArea placeholder={'请填写说明'} rows={3} maxLength={200} showCount
                      onChange={(e) => form.setFieldValue('describe', trimStr(e.target.value))} />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}